import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const createRouter = () =>
    new Router({
        mode: 'history',
        scrollBehavior: (to, from) => {
            if (from?.path === to?.path) {
                return null;
            } else {
                // window.scrollTo(0, 0);
                return { x: 0, y: 0, behavior: 'smooth' };
            }
        },
        // scrollBehavior: to => {
        //   if (to.params.scrollTo) {
        //     window.scrollTo({
        //       top: to.params.scrollTo.y,
        //       left: to.params.scrollTo.x,
        //       behavior: 'smooth'
        //     });
        //   } else {
        //     window.scrollTo({
        //       top: 0,
        //       behavior: 'smooth'
        //     });
        //   }
        // },
        linkActiveClass: 'active',
        base: __dirname,
        routes: []
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;
